export const FLOW_STEP = {
  SALES_FLOW: 'SALES_FLOW',
  WAITING: 'WAITING',
  QUOTE_GENERATED: 'QUOTE_GENERATED',
  POLICY_SOLD: 'POLICY_SOLD',
};
